<!--
  Same popover as the customers Filter menu (`.tr-popover-menu`). On <body> so no
  toolbar or scroll container can clip it.
-->
<div
  ngbDropdown
  container="body"
  placement="bottom-start bottom-end top-start top-end"
  (openChange)="$event && buildMenu()"
>
  <button
    ngbDropdownToggle
    type="button"
    class="btn btn-outline-border tr-table-settings__btn d-inline-flex align-items-center justify-content-center"
    [attr.title]="unsaved ? label + ' — unsaved layout changes' : label"
    [attr.aria-label]="label"
    [attr.data-testid]="'table-settings-btn-' + (stateId || 'unbound')"
  >
    <i class="bi bi-gear"></i>

    <!--
      Unsaved-layout marker: the notification bubble's red, shrunk to a dot with no
      count, because there is nothing to count — either the layout differs from the
      location default or it doesn't.
    -->
    <span
      *ngIf="unsaved"
      class="tr-table-settings__dot"
      data-testid="table-settings-unsaved"
      aria-hidden="true"
    ></span>
  </button>

  <div
    ngbDropdownMenu
    class="tr-popover-menu"
    [attr.data-testid]="'table-settings-menu-' + (stateId || 'unbound')"
  >
    <h6 class="dropdown-header">Table Settings</h6>
    <ng-container *ngFor="let item of menuItems">
      <div *ngIf="item.separator; else action" class="dropdown-divider"></div>
      <ng-template #action>
        <button
          ngbDropdownItem
          type="button"
          [disabled]="item.disabled"
          [attr.data-testid]="'table-settings-item-' + item.id"
          (click)="item.command?.()"
        >
          <i [class]="item.icon + ' mr-2'" aria-hidden="true"></i>
          {{ item.label }}
        </button>
      </ng-template>
    </ng-container>
  </div>
</div>
